import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DisciplinaActions } from 'Store/Disciplina/Disciplina.actions';
import { IDisciplineRequest } from 'Data/interfaces/Obra/IDisciplineRequest';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import Field from 'Components/UI/Field';
import Form from 'Components/UI/Form/Form';
import schema from './cadastroDisciplina.schema';
import { ButtonsWrapper, DisciplinaWrapper } from './styles';

interface ICadastroDisciplina {
  visible?: boolean;
  id?: number;
  description?: string;
  constructionSiteId: number;
  loading?: boolean;
  onCancel: () => void;
}

const CadastroDisciplina: FC<ICadastroDisciplina> = ({
  visible,
  id,
  description,
  constructionSiteId,
  loading,
  onCancel,
}) => {
  const dispatch = useDispatch();

  const [isSubmit, setIsSubmit] = useState(false);

  const submit = (values: any) => {
    const discipline: IDisciplineRequest = {
      ConstructionSiteId: constructionSiteId,
      Name: values.description,
    };
    if (id) {
      discipline.Id = id;
    }
    dispatch(DisciplinaActions.createOrUpdate(discipline));
    setIsSubmit(false);
  };

  const buttons = (
    <ButtonsWrapper>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
      >
        Cancelar
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => setIsSubmit(true)}
        className="buttonSubmit"
        disabled={loading}
        loading={loading}
      >
        Continuar
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      visible={visible}
      title={id ? 'Editar disciplina' : 'Criar nova disciplina'}
      footerButtons={buttons}
      footerActive={false}
      width={600}
      customClassName
      newHeader
      onCancel={onCancel}
    >
      <DisciplinaWrapper>
        <Form
          schema={schema}
          isSubmited={isSubmit}
          className='disciplinaForm'
          onSubmit={submit}
        >
          <Field
            label='Nome da Disciplina'
            name='description'
            className='inputDescription'
            defaultValue={description}
            disabled={loading}
          />
        </Form>
      </DisciplinaWrapper>
    </Modal>
  );
};

export default CadastroDisciplina;
